export default "__VITE_ASSET__D0AiHK4w__"